module.exports = __webpack_public_path__ + "img/KarlusMorales_Imagotype_Short_Light.c18b1ebc.svg";